var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 5.8125H7.1875V1.6875C7.1875 1.50516 7.11507 1.3303 6.98614 1.20136C6.8572 1.07243 6.68234 1 6.5 1C6.31766 1 6.1428 1.07243 6.01386 1.20136C5.88493 1.3303 5.8125 1.50516 5.8125 1.6875V5.8125H1.6875C1.50516 5.8125 1.3303 5.88493 1.20136 6.01386C1.07243 6.1428 1 6.31766 1 6.5C1 6.68234 1.07243 6.8572 1.20136 6.98614C1.3303 7.11507 1.50516 7.1875 1.6875 7.1875H5.8125V11.3125C5.8125 11.4948 5.88493 11.6697 6.01386 11.7986C6.1428 11.9276 6.31766 12 6.5 12C6.68234 12 6.8572 11.9276 6.98614 11.7986C7.11507 11.6697 7.1875 11.4948 7.1875 11.3125V7.1875H11.3125C11.4948 7.1875 11.6697 7.11507 11.7986 6.98614C11.9276 6.8572 12 6.68234 12 6.5C12 6.31766 11.9276 6.1428 11.7986 6.01386C11.6697 5.88493 11.4948 5.8125 11.3125 5.8125Z",
    fill: "#212529",
    stroke: "#FFD822",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.7b4873ef892fdde543c6ee6caa1c3a74.svg";
export { ForwardRef as ReactComponent };